export const diseases_bwcallergy_eng = [
  {
    label: 'Allergic rhinitis',
    label_show: 'Allergic Rhinitis',
    page: 6,
    Xpos_image: '156px',
    Ypos_image: '460px',
    Xlabel: '155px',
    Ylabel: '550px',
    width: '79px',
    height: 'auto',
    result_comp: [
      { min: 1, max: 3, image: 'allergicrhiniitis_0' },
      { min: 4, max: 6, image: 'allergicrhiniitis_1' },
      { min: 7, max: 10, image: 'allergicrhiniitis_2' }
    ]
  },
  {
    label: 'Asthma',
    label_show: 'Asthma',
    page: 6,
    Xpos_image: '292px',
    Ypos_image: '460px',
    Xlabel: '310px',
    Ylabel: '550px',
    width: '79px',
    height: 'auto',
    result_comp: [
      { min: 1, max: 3, image: 'asthma_0' },
      { min: 4, max: 6, image: 'asthma_1' },
      { min: 7, max: 10, image: 'asthma_2' }
    ]
  },
  {
    label: 'Eczema',
    label_show: 'Eczema',
    page: 6,
    Xpos_image: '426px',
    Ypos_image: '460px',
    Xlabel: '444px',
    Ylabel: '550px',
    width: '79px',
    height: 'auto',
    result_comp: [
      { min: 1, max: 3, image: 'eczema_0' },
      { min: 4, max: 6, image: 'eczema_1' },
      { min: 7, max: 10, image: 'eczema_2' }
    ]
  },
  {
      label: 'Food allergy',
      label_show: 'Food Allergy',
      page: 6,
      Xpos_image: '561px',
      Ypos_image: '460px',
      Xlabel: '566px',
      Ylabel: '550px',
      width: '79px',
      height: 'auto',
      result_comp: [
        { min: 1, max: 3, image: 'foodallergy_0' },
        { min: 4, max: 6, image: 'foodallergy_1' },
        { min: 7, max: 10, image: 'foodallergy_2' }
      ]
  }
]

export const diseases_bwcallergy_thai = [
  {
    label: 'Allergic rhinitis',
    label_show: 'ภูมิแพ้อากาศ',
    page: 5,
    Xpos_image: '156px',
    Ypos_image: '460px',
    Xlabel: '165px',
    Ylabel: '550px',
    width: '79px',
    height: 'auto',
    result_comp: [
      { min: 1, max: 3, image: 'allergicrhiniitis_0' },
      { min: 4, max: 6, image: 'allergicrhiniitis_1' },
      { min: 7, max: 10, image: 'allergicrhiniitis_2' }
    ]
  },
  {
    label: 'Asthma',
    label_show: 'หอบหืด',
    page: 5,
    Xpos_image: '292px',
    Ypos_image: '460px',
    Xlabel: '315px',
    Ylabel: '550px',
    width: '79px',
    height: 'auto',
    result_comp: [
      { min: 1, max: 3, image: 'asthma_0' },
      { min: 4, max: 6, image: 'asthma_1' },
      { min: 7, max: 10, image: 'asthma_2' }
    ]
  },
  {
    label: 'Eczema',
    label_show: 'ภูมิแพ้ผิวหนังอักเสบ',
    page: 5,
    Xpos_image: '426px',
    Ypos_image: '460px',
    Xlabel: '418px',
    Ylabel: '550px',
    width: '79px',
    height: 'auto',
    result_comp: [
      { min: 1, max: 3, image: 'eczema_0' },
      { min: 4, max: 6, image: 'eczema_1' },
      { min: 7, max: 10, image: 'eczema_2' }
    ]
  },
  {
      label: 'Food allergy',
      label_show: 'ภูมิแพ้อาหาร',
      page: 5,
      Xpos_image: '561px',
      Ypos_image: '460px',
      Xlabel: '570px',
      Ylabel: '550px',
      width: '79px',
      height: 'auto',
      result_comp: [
        { min: 1, max: 3, image: 'foodallergy_0' },
        { min: 4, max: 6, image: 'foodallergy_1' },
        { min: 7, max: 10, image: 'foodallergy_2' }
      ]
  }
]

export const diseases_image_bwcallergy_eng = [
  // {
  //   label: 'Eczema',
  //   label_show: 'Eczema',
  //   page: 12,
  //   Xpos_image: '77px',
  //   Ypos_image: '685px',
  //   Xlabel: '90px',
  //   Ylabel: '757px',
  //   width: '70px',
  //   height: 'auto'
  // },
];

export const diseases_image_bwcallergy_thai = [
  // {
  //   label: 'Eczema',
  //   label_show: 'Eczema',
  //   page: 12,
  //   Xpos_image: '77px',
  //   Ypos_image: '685px',
  //   Xlabel: '90px',
  //   Ylabel: '757px',
  //   width: '70px',
  //   height: 'auto'
  // },
];